import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ApiService from "../../helper/api";
import AlertService from "../../helper/alertService";
import { LoadingContext } from "../../App";
import ActionButton from "../../componets/ActionButon";

const NetworkForm = ({ network, closeModal, isShowForm }) => {
	const { addButtonSpinner, removeButtonSpinner } = useContext(LoadingContext);
	const navaigate = useNavigate();
	const [networkTypes, setNetworkTypes] = useState([]);
	const [values, setValues] = useState({
		name: "",
		webAddress: "",
		isActive: false,
		urlAddress: [""],
		dataAddress: [""],
		networkType: "",
		apiKey: "",
		urls: [],
	});

	useEffect(() => {
		if (network) {
			const newValues = {};
			Object.entries(values).forEach(([key, value]) => {
				if (network[key]) {
					newValues[key] = network[key];
				}
			});
			newValues.id = network.id;
			setValues(values => ({ ...values, ...newValues }));
		}
	}, [network]);

	useEffect(() => {
		getNetworkTypes();
	}, []);

	const getNetworkTypes = () => {
		ApiService.getNetworkTypes()
			.then(response => {
				if (response.data) {
					setNetworkTypes(response.data);
				} else {
					setNetworkTypes([]);
				}
			})
			.catch(error => {
				AlertService.alert("error", error);
			});
	};

	const onChange = (event, name) => {
		setValues(values => ({
			...values,
			[name]: event.target.value,
		}));
	};

	// const onChangeArray = (evenet, name, index) => {
	// 	const newArrayValues = values[name];
	// 	if (Array.isArray(newArrayValues)) {
	// 		newArrayValues[index] = evenet.target.value;
	// 		setValues({
	// 			...values,
	// 			[name]: newArrayValues,
	// 		});
	// 	}
	// };

	const handleChange = (event, fieldName) => {
		setValues(value => ({ ...value, [fieldName]: event.target.value }));
	};
	const onSubmit = e => {
		e && e.preventDefault();
		const id = Math.random();
		addButtonSpinner(id);
		if (network) {
			values.id = network.id;
		}
		(!network
			? ApiService.createNetworkPlatform(values)
			: ApiService.updateNetworkPlatform(values)
		)
			.then(response => {
				AlertService.alert("success", "Data Saved");
				_closeModal();
				if (response.data) {
					navaigate(`/network-platform-view/${response.data.id}`);
				} else if (network) {
					navaigate(`/network-platform-view/${network.id}`);
				} else {
					navaigate(`/network-platform`);
				}
			})
			.catch(error => {
				AlertService.alert(
					AlertService.checkMessageType(error.respcode) || "error",
					error,
				);
			})
			.finally(() => {
				removeButtonSpinner(id);
			});
	};

	const _closeModal = () => {
		setValues({
			name: "",
			webAddress: "",
			docsAddress: "",
			isActive: false,
			urlAddress: "",
			dataAddress: "",
			networkType: "",
			apiKey: "",
			urls: [],
		});
		closeModal();
	};

	return (
		<form onSubmit={onSubmit}>
			<Modal
				show={isShowForm || network}
				size="lg"
				scrollable
				onHide={() => {
					_closeModal();
				}}>
				<Modal.Header closeButton>
					<Modal.Title>{network ? "Update" : "Create"} Network</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={12}>
							<Row>
								{/* Name */}
								<Col md={5}>
									<Form.Group className="mb-1" controlId="name">
										<Form.Label>Name</Form.Label>
										<Form.Control
											type="text"
											placeholder="Name"
											value={values.name}
											onChange={event => {
												onChange(event, "name");
											}}
										/>
									</Form.Group>
								</Col>
								<Col md={1}></Col>

								{/* Is active */}
								<Col md={2}>
									<Form.Group className="mb-1" controlId="isActive">
										<Form.Label>Is active </Form.Label>
										<Form.Check // prettier-ignore
											type="switch"
											id="isActive"
											label="yes"
											checked={values.isActive}
											onChange={event => {
												setValues(values => ({
													...values,
													isActive: event.target.checked,
												}));
											}}
										/>
									</Form.Group>
								</Col>
							</Row>
						</Col>

						{/* Network Type */}
						<Col md={12}>
							<hr />
						</Col>
						<Col md={5}>
							<Form.Group className="mb-3">
								<Form.Label>Network Type</Form.Label>
								{networkTypes && networkTypes.length ? (
									<Form.Select
										onChange={event => handleChange(event, "networkType")}>
										<option value={null} hidden>
											{values && values.networkType
												? values.networkType
												: "Select Network Type"}
										</option>
										{networkTypes.map(
											(key, index) =>
												key !== values.networkType && (
													<option key={index} value={key}>
														{key}
													</option>
												),
										)}
									</Form.Select>
								) : null}
							</Form.Group>
						</Col>
						<Col md={12}>
							<hr />
						</Col>
						{/* Api Key */}
						<Col md={12}>
							<Form.Group className="mb-1" controlId="apiKey">
								<Form.Label>Api Key</Form.Label>
								<Form.Control
									type="text"
									placeholder="apiKey"
									value={values.apiKey}
									onChange={event => {
										onChange(event, "apiKey");
									}}
								/>
							</Form.Group>
						</Col>

						<Col md={12}>
							<hr />
						</Col>

						<Col md={12}>
							<Row>
								{/* Web Address */}
								<Col md={6}>
									<Form.Group className="mb-1" controlId="webAddress">
										<Form.Label>Web Address</Form.Label>
										<Form.Control
											type="text"
											placeholder="webAddress"
											value={values.webAddress}
											onChange={event => {
												onChange(event, "webAddress");
											}}
										/>
									</Form.Group>
								</Col>

								{/* Doc Address */}
								<Col md={6}>
									<Form.Group className="mb-1" controlId="docsAddress">
										<Form.Label>Doc Address</Form.Label>
										<Form.Control
											type="text"
											placeholder="docsAddress"
											value={values.docsAddress}
											onChange={event => {
												onChange(event, "docsAddress");
											}}
										/>
									</Form.Group>
								</Col>

								{/* Url address */}
								<Col md={6}>
									<Form.Group className="mb-1" controlId="urlAddress">
										<Form.Label>Url address</Form.Label>
										<Form.Control
											type="text"
											placeholder="urlAddress"
											value={values.urlAddress}
											onChange={event => {
												onChange(event, "urlAddress");
											}}
										/>
									</Form.Group>
								</Col>

								{/* Data address */}
								<Col md={6}>
									<Form.Group className="mb-1" controlId="dataAddress">
										<Form.Label>Data address</Form.Label>
										<Form.Control
											type="text"
											placeholder="dataAddress"
											value={values.dataAddress}
											onChange={event => {
												onChange(event, "dataAddress");
											}}
										/>
									</Form.Group>
								</Col>
							</Row>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					{/* <Button variant="secondary" onClick={handleClose}>
						Close
					</Button>
					<Button variant="primary" onClick={handleClose}>
						Save Changes
					</Button> */}
					<Col md={12}>
						<ActionButton
							cb={onSubmit}
							isEnabled={!values.networkType || !values.name}
						/>
					</Col>
				</Modal.Footer>
			</Modal>
		</form>
	);
};
// const loader = async ({ request, params: { networkId } }) => {
// 	if (!networkId) {
// 		return { network: null, urlTypes: [], urlNames: [] };
// 	}
// 	try {
// 		const network = await ApiService.getNetworkPlatformByid(networkId)
// 			.then(response => {
// 				if (response.data) {
// 					return response.data;
// 				} else {
// 					return {};
// 				}
// 			})
// 			.catch(error => {
// 				AlertService.alert("error", error);
// 			});

// 		return { network };
// 	} catch (error) {
// 		AlertService.alert("error", error);
// 		return error;
// 	}
// };
// const NetworkForm = Object.assign(Componet, { loader });
export default NetworkForm;
